/* eslint-disable jsx-a11y/anchor-is-valid */

import axios from 'axios';
import ja from 'date-fns/locale/ja';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import Micromodal from 'micromodal';
import { FC, useEffect, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from 'react-number-format';
import { Link, useHistory } from 'react-router-dom';
import { Setting, statusMessages } from '../App';
import { SpinButton } from '../components/SpinButton';
import { Spinner } from '../components/Spinner';
import { AddProducts } from '../components/SubscriptionDetail/AddProducts';
import { ChangeQuantity } from '../components/SubscriptionDetail/ChangeQuantity';
import { CUSTOMER_API_URL } from '../constants';
import { useMetafieldData } from '../hooks/use-metafield-data';
import { useSubscriptionDetail } from '../hooks/use-subscription-detail';
import { Product, useSubscriptionLineEditProduct } from '../hooks/use-subscription-line-edit-product';
import { productsData } from '../productsDataPrd';
import base from '../styles/Base.module.css';
import style from '../styles/SubscriptionDetail.module.css';

registerLocale('ja', ja);

export type StatusMessage = keyof typeof statusMessages;

dayjs.extend(weekday);

export const SubscriptionDetailShokutasu: FC<{ setting: Setting }> = ({ setting }) => {
  const [targetLineQuantity, setTargetLineQuantity] = useState<number>(1);
  const history = useHistory();

  // const [targetLineQuantity, setTargetLineQuantity] = useState<number>(1);
  const [targetVariantId, setTargetVariantId] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [targetSubscriptionContractId, setTargetSubscriptionContractId] = useState<string>('');
  const [targetLineId, setTargetLineId] = useState<string>('');

  const [productDetailModalDisplay, setProductDetailModalDisplay] = useState(false);
  const [productQuantityModalDisplay, setProductQuantityModalDisplay] = useState(false);

  const [modalMainImage, setModalMainImage] = useState<string>('');
  const [targetProductDetail, setTargetProductDetail] = useState<any>(null);

  const reactRouterHistory = useHistory();
  const { getRegistrableVariants } = useMetafieldData();
  const [productsInfo, setProductsInfo] = useState<any[]>([]);
  const [isLargeWindowSize, setIsLargeWindowSize] = useState<boolean>();

  const { products, infoMessage, page, hasNextPage, paginate, allProducts } = useSubscriptionLineEditProduct(setting);

  const { onClickShokutasuQuantityAction } = useSubscriptionDetail(setting);

  const {
    subscription,
    updateStatus,
    deliveryDate,
    updateStatusOpen,
    subscriptionLinePlan,
    removeItem,
    onClickRemoveProduct,
    onClickRemoveAction,
    pageStatus,
    skipCount,
    openNewOrderModal,
    onClickNewOrderAction,
    onClickQuantityModify,
    onClickQuantityAction,
    onChangeQuantity,
    quantityItem,
    openPlanModifyModal,
    planGroups,
    getPlanModifyList,
    cancelSurveySetting,
    cancelSurveyInput,
    setCancelSurveyInput,
    openPaymentChange,
    allowModifyDay,
    selectNoDay,
    updateSubscription,
  } = useSubscriptionDetail(setting);

  useEffect(() => {
    if (!subscription) return;

    window.addEventListener('message', (e) => {
      if (e.data.windownnerWidth) {
        setIsLargeWindowSize(e.data.windownnerWidth > 999);
      }
    });

    window.parent.postMessage({ action: 'renderSubcription' }, '*');

    const fetchProductsInfo = async () => {
      const products = await Promise.all(
        subscription.subscriptionLines.map(async (subscriptionLine) => {
          const productInfo = await getRegistrableVariants(subscriptionLine.productId);
          return productInfo;
        }),
      );
      setProductsInfo(products);
    };

    fetchProductsInfo();
  }, [subscription, getRegistrableVariants]);

  if (!products) {
    return <></>;
  }
  if (!subscription) {
    return (
      <>
        <Spinner isLoading={true} />
      </>
    );
  }

  const handleImageClick = async (product: Product) => {
    console.log('product', product);
    const product_handle = product.onlineStorePreviewUrl?.slice(-11);
    console.log('product_handle', product_handle);
    console.log('productsData', productsData);
    const target_product = productsData.find((p) => product.onlineStorePreviewUrl?.includes(p.url));
    console.log('target_product', target_product);
    setProductDetailModalDisplay(true);
    setTargetProductDetail({
      ...target_product,
      onlineStorePreviewUrl: product.onlineStorePreviewUrl,
    });
    setModalMainImage(target_product!.featured_image);
  };

  const handleAddProduct = (product: any) => {
    console.log('product', product);
    const product_handle = product.onlineStorePreviewUrl?.slice(-11);
    console.log('product_handle', product_handle);
    console.log('productsData', productsData);
    const target_product = productsData.find((p) => product.onlineStorePreviewUrl?.includes(p.url));
    console.log('target_product', target_product);
    setProductDetailModalDisplay(true);
    setTargetProductDetail({
      ...target_product,
      ...product,
      onlineStorePreviewUrl: product.onlineStorePreviewUrl,
    });

    setModalMainImage(target_product!.featured_image);
  };

  const handleQuantity = (product: any, defaultQuantity: number, subscriptionContractId: string) => {
    console.log('product', product);
    const product_handle = product.onlineStorePreviewUrl?.slice(-11);
    console.log('product_handle', product_handle);
    console.log('productsData', productsData);
    const target_product = productsData.find((p) => product.onlineStorePreviewUrl?.includes(p.url));
    console.log('target_product', target_product);
    setTargetLineQuantity(defaultQuantity);
    setTargetVariantId(product.variants[0].id);
    setTargetSubscriptionContractId(subscriptionContractId);
    setTargetLineId(
      subscription!.subscriptionLines.find((line) => line.variantId.includes(product.variants[0].id.toString()))!.lineId,
    );
    setProductQuantityModalDisplay(true);
    setTargetProductDetail({
      ...target_product,
      onlineStorePreviewUrl: product.onlineStorePreviewUrl,
    });
    // setTargetProductDetailMetafields(
    //   target_product
    //     ? target_product.metafields?.map((mf) => {
    //         return {
    //           ...mf,
    //           open: false,
    //         };
    //       })
    //     : []
    // );
    setModalMainImage(target_product!.featured_image);
    console.log('targetProductDetail', targetProductDetail);
    console.log('targetLineId', targetProductDetail);
  };

  const updateQuantity = () => {
    console.log('targetProductDetail', targetProductDetail);
    onClickShokutasuQuantityAction({
      variantId: `gid://shopify/ProductVariant/${targetProductDetail.variants[0].id}`,
      subscriptionId: targetSubscriptionContractId,
      lineId: targetLineId,
      quantity: targetLineQuantity,
    });
  };

  const handlePreviewImageClick = (src: string) => {
    setModalMainImage(src);
  };

  // この商品を追加する ボタンのクリック時の処理
  const handleAddItem = async () => {
    if (subscription!.shop.showStockAlert) {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=checkVariantSoldOut`,
          {
            variantId: `gid://shopify/ProductVariant/${targetProductDetail.variants[0].id}`,
          },
          {
            headers: { Authorization: setting.token },
          },
        );

        if (response.data.soldOut) {
          Micromodal.show('modal-stock-error');

          return;
        }
      } catch (e) {
        console.log((e as Error).message);

        return;
      }
    }
    setIsLoading(true);
    console.log('handleAddItem');
    console.log('targetProductDetail', targetProductDetail);
    console.log('subscription', subscription);
    // console.log('id', id);
    // console.log('productId', productId);
    // console.log('lineId', lineId);
    // const res_data = await loadSubscriptionLinePlanForOnHandleAddItem({ id: subscription!.subscriptionContractId });
    // console.log('res_data', res_data);
    let sellingPlanName = '';
    // if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/6021873854') {

    // dev
    // if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/6021873854') {
    //   sellingPlanName = '週1回お届けプラン';
    // } else if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/6024298686') {
    //   sellingPlanName = '2週に1回お届けプラン';
    // } else {
    //   sellingPlanName = '4週に1回お届けプラン';
    // }

    // stg
    if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/4637458672') {
      sellingPlanName = '週1回お届けプラン';
    } else if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/4637491440') {
      sellingPlanName = '2週に1回お届けプラン';
    } else {
      sellingPlanName = '4週に1回お届けプラン';
    }

    // prd
    // if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/4637458672') {
    //   sellingPlanName = '週1回お届けプラン';
    // } else if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/4637491440') {
    //   sellingPlanName = '2週に1回お届けプラン';
    // } else {
    //   sellingPlanName = '4週に1回お届けプラン';
    // }
    // onHandleAddItem({
    //   // id: 'gid%3A%2F%2Fshopify%2FSubscriptionContract%2F3215687870',
    //   id: id,
    //   planId: subscription!.subscriptionLines[0].sellingPlanId!,
    //   planName: sellingPlanName,
    //   // subscriptionLineOnlineStorePreviewUrl: `https://hamaya-jt-dev.myshopify.com${targetProductDetail.url}`,
    //   subscriptionLineOnlineStorePreviewUrl: `https://tablemark-stg.myshopify.com${targetProductDetail.url}`,
    //   productId: productId,
    //   // variantId: 'gid://shopify/ProductVariant/42893764755710',
    //   variantId: `gid://shopify/ProductVariant/${targetProductDetail.variants[0].id}`,
    //   // variantImage: 'https://cdn.sh  opify.com/s/files/1/0638/1014/2462/products/BE-0017-001_01.png?v=1655178948',
    //   variantImage: targetProductDetail.featured_image,
    //   title: targetProductDetail.title,
    //   // variantTitle: targetProductDetail.variants[0].name,
    //   variantTitle: '',
    //   quantity: '1',
    //   variantPrice: (targetProductDetail.variants[0].price / 100).toString(),
    //   variantSku: targetProductDetail.variants[0].sku
    // })
    //   .then(() => {
    //     setIsLoading(false);
    //   })
    //   .catch(() => {
    //     setIsLoading(false);
    //   });
    // onSelectItem();
  };

  if (!subscription) {
    return <></>;
  }
  console.log('subscription', subscription);

  const {
    subscriptionContractId,
    billingPolicyInterval,
    billingPolicyIntervalCount,
    billingPolicyMinCycles,
    nextBillingDate,
    // customerId,
    status,
    deliveryPriceAmount,
    deliveryPriceCurrencyCode,
    deliveryFormattedAddress,
    paymentType,
  } = subscription;

  const billingAttempts = [
    ...subscription.billingAttempts.map((billingAttempt) => {
      let status;
      let isError = false;
      if (!billingAttempt.ready) {
        status = '実行中';
      } else if (billingAttempt.orderId) {
        status = '成功';
      } else {
        status = `失敗${'（' + billingAttempt.errorMessage! + '）'}`;
        isError = true;
      }

      return {
        orderId: billingAttempt.orderId,
        orderToken: billingAttempt.orderToken,
        orderName: billingAttempt.orderName,
        status,
        createdAt: billingAttempt.createdAt,
        isError,
      };
    }),

    {
      orderId: subscription.originOrderId,
      orderToken: subscription.originOrderToken,
      orderName: subscription.originOrderName,
      status: '成功',
      createdAt: subscription.createdAt,
      isError: false,
    },
  ];

  // BOX のサブスクリプションかを判定
  const boxPlanGroup =
    planGroups.length > 0 &&
    planGroups.find((planGroup) => {
      return planGroup.boxes?.some((box) => {
        return subscription!.subscriptionLines.map((p) => p.productId).some((productId) => box.parentProductId === productId);
      });
    });

  // boxPlanGroup = false: 読込中
  const isBoxSubscription = !!boxPlanGroup;

  // TODO
  const deliveryPriceCurrency = deliveryPriceCurrencyCode === 'JPY' ? '￥' : deliveryPriceCurrencyCode;

  let productNewAddAction = <></>;
  if (subscription.shop.showNewAddProduct && !isBoxSubscription && boxPlanGroup !== false) {
    productNewAddAction = (
      <Link to={`/subscriptions/${encodeURIComponent(subscriptionContractId)}/lines/new`}>
        <span className="huckleberry-subscription-detail-btn new-add">他の商品を定期購買に追加する</span>
      </Link>
    );
  }

  const boxProductEditAction =
    isBoxSubscription && boxPlanGroup && boxPlanGroup.boxes?.length ? (
      <Link
        to={`/subscriptions/${encodeURIComponent(subscriptionContractId)}/box/${encodeURIComponent(
          boxPlanGroup.boxes[0].boxId!,
        )}`}
      >
        <span className="huckleberry-subscription-detail-btn new-add">BOXの商品を変更する</span>
      </Link>
    ) : (
      <></>
    );

  const productCount = subscription.subscriptionLines.length;

  let newOrderAction = <></>;
  if (subscription.shop.showNewOrder && subscription.status !== 'PAUSED') {
    newOrderAction = (
      <button className={`${base.sectionBtn} add`} onClick={openNewOrderModal}>
        追加購入する
      </button>
    );
  }

  const discountPriceSubtotal = subscription.subscriptionLines.reduce(
    (total, line) => total + line.currentPriceAmount * line.quantity,
    0,
  );

  let couponDiscountPrice = 0;
  console.log('Discount', subscription.subscriptionDiscounts);
  if (subscription.subscriptionDiscounts.length > 0) {
    // 割引率設定のとき
    if (subscription.subscriptionDiscounts[0].percentage) {
      if (subscription.subscriptionDiscounts[0].deliveryDiscount === false) {
        couponDiscountPrice = Math.floor((discountPriceSubtotal * subscription.subscriptionDiscounts[0].percentage) / 100);
      }
      // 定額割引設定のとき
    } else if (subscription.subscriptionDiscounts[0].amount) {
      couponDiscountPrice = subscription.subscriptionDiscounts[0].amount;
    }
  }

  console.log('couponDiscountPrice', couponDiscountPrice);

  const totalPrice =
    subscription.subscriptionLines.reduce(
      (total, line) => total + line.currentPriceAmount * line.quantity,
      deliveryPriceAmount,
    ) - couponDiscountPrice;

  return (
    <>
      {/* 注文詳細 */}
      <div className={style.detailMain}>
        <div className={style.detailMainNextDeliveryProductsContent}>
          <h1 className={base.pageHeading}>
            Subscription
            <span className={isLargeWindowSize ? base.large : base.normal}>定期便のお届け商品の追加・変更</span>
          </h1>
          {/* 次回お届け商品 */}
          <div className={`${style.detailMainNextDeliveryProducts} ${style.detailMainBlock}`}>
            {/* style.detailMainNextDeliveryProductsContent */}
            <div className={style.detailMainNextDeliveryProductsContentBlock}>
              <h2 className={`${base.sectionHeading}`}>次回のお届け内容</h2>
              {subscription.subscriptionLines
                .sort((first, line) => {
                  // 親商品を常に上に表示する
                  const isParent =
                    boxPlanGroup &&
                    boxPlanGroup.boxes.some((box) => {
                      return box.parentProductId === line.productId;
                    });
                  return isParent ? 1 : 0; // 親商品以外は０を返して並びを維持する
                })
                .map((line, index) => {
                  // TODO
                  const currency = line.lineDiscountedPriceCurrencyCode === 'JPY' ? '円' : line.lineDiscountedPriceCurrencyCode;

                  const title = line.title;
                  // const title = line.variantTitle ? `${line.title} - ${line.variantTitle}` : line.title;

                  let productQuantityAction = <></>;
                  if (
                    subscription.shop.showChangeQuantity &&
                    planGroups.length > 0 &&
                    !isBoxSubscription &&
                    boxPlanGroup !== false
                  ) {
                    productQuantityAction = (
                      <button
                        className="huckleberry-subscription-detail-btn change-amount"
                        disabled={subscription.disabled}
                        onClick={() => {
                          onClickQuantityModify(line);
                        }}
                      >
                        数量の変更
                      </button>
                    );
                  }

                  let lineQuantity = line.quantity;

                  let productTitleHtml = <>{title}</>;

                  const productInfo = productsInfo.find((productInfo) => productInfo.productId === line.productId);

                  const image = productInfo?.featuredImage ? productInfo.featuredImage : line.variantImage;

                  return (
                    <article key={index} className={base.productItem}>
                      <div className={style.productSummary}>
                        <div className={style.productImageTitleBlock}>
                          <img src={image} alt={line.title} className={style.productImage} />
                          {/* <p>{title}</p> */}
                          <div className={style.productDetail}>
                            <p className={style.productTitle}>{productTitleHtml}</p>
                            {/* 価格 */}
                            <p className={style.productDetailPrice}>
                              <span className={style.productDetailPriceTitle}>定期便価格</span>
                              <NumberFormat
                                displayType="text"
                                value={
                                  // line.lineDiscountedPriceAmount
                                  line.currentPriceAmount
                                }
                                thousandSeparator={true}
                                prefix={deliveryPriceCurrency}
                              />
                            </p>

                            <div className={style.productQuantityBlock}>
                              <ChangeQuantity
                                subscriptionContactId={subscription.subscriptionContractId}
                                line={line}
                                setting={setting}
                                updateSubscription={updateSubscription}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  );
                })}

              {/* /お支払い金額 */}

              {/* 金額 */}
              <div className={style.productsPrice}>
                {/* 商品合計・送料 */}
                <div className={style.partialPrice}>
                  {/* 商品合計（税込） */}
                  <div className={`${style.partialPriceProductsPrice} ${style.partialPriceItem}`}>
                    <p>商品小計</p>
                    <p className={style.detailPriceColor}>
                      <NumberFormat
                        displayType="text"
                        value={discountPriceSubtotal}
                        thousandSeparator={true}
                        prefix={deliveryPriceCurrency}
                      />
                    </p>
                  </div>

                  {/* 送料 */}
                  {totalPrice <= 5000 ? (
                    <div className={`${style.partialPriceShippingPrice} ${style.partialPriceItem}`}>
                      <p>送料</p>
                      <p>
                        <NumberFormat
                          displayType="text"
                          value={
                            totalPrice > 5000 ? 0 : deliveryPriceAmount //5000円以上なら送料無料
                          }
                          thousandSeparator={true}
                          prefix={deliveryPriceCurrency}
                        />
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}

                  {/* クーポン */}
                  {couponDiscountPrice > 0 && (
                    <div className={`${style.partialPriceShippingPrice} ${style.partialPriceItem}`}>
                      <p>割引額</p>
                      <p>
                        -
                        <NumberFormat
                          displayType="text"
                          value={couponDiscountPrice}
                          thousandSeparator={true}
                          prefix={deliveryPriceCurrency}
                        />
                      </p>
                    </div>
                  )}
                </div>
                {/* /商品合計・送料 */}

                {/* お支払い金額 */}
                <div className={style.totalPrice}>
                  {/* 合計金額 */}
                  <div className={style.totalPriceSummary}>
                    <p>税込合計</p>
                    <p>
                      <NumberFormat
                        className={style.detailPriceColor}
                        displayType="text"
                        value={totalPrice}
                        thousandSeparator={true}
                        prefix={deliveryPriceCurrency}
                      />
                    </p>
                  </div>
                </div>
              </div>
              {/* /金額 */}
            </div>
            {/* /style.detailMainNextDeliveryProductsContent */}

            {/* style.detailMainNextDeliveryProductsButton */}
            {/* <div className={style.detailMainNextDeliveryProductsButtonBlock}>
              {
                // お届商品の追加・変更期限日の日付が、本日より前の場合（.diff()で1以上を返す場合）は、お届け商品の追加・変更ボタンを表示しない
                dayjs(subscription.nextBillingDate).subtract(3, 'day').diff(dayjs(), 'day') > 0 && (
                  <Link
                    className={`${style.detailMainNextDeliveryProductsButton} ${base.sectionBtn} ${base.productsAddAndChangeBtn}`}
                    to={`/subscriptions/${encodeURIComponent(subscriptionContractId)}/products/${encodeURIComponent(
                      subscription.subscriptionLines[0].productId
                    )}/lines/${encodeURIComponent(subscription.subscriptionLines[0].lineId)}/lines-edit`}
                  >
                    お届け商品の追加・変更
                  </Link>
                )
              }
            </div> */}
            {/* /style.detailMainNextDeliveryProductsButton */}
          </div>
          {/* /次回お届け商品 */}
        </div>

        {/* 追加商品 */}
        <AddProducts subscription={subscription} setting={setting} />

        {/* 定期購入一覧に戻る */}
        <div className={`${base.flexJC} ${base.mt20}`}>
          <Link className={`${base.sectionReverseBtn} ${base.cancelUpdateAddress}`} to="/">
            マイページに戻る
          </Link>
        </div>
        {/* /定期購入一覧に戻る */}

        <div className="micromodal" id="modal-remove-product" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-remove-product-title"
            >
              <header>
                <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
                <h2 id="modal-remove-product-title">商品の削除</h2>
              </header>
              <main id="modal-remove-product-content">
                <p>「{removeItem ? removeItem.title : ''}」を削除します。よろしいですか？</p>
              </main>
              <footer>
                <button className={base.sectionBtn} onClick={onClickRemoveAction} disabled={pageStatus.removeAction}>
                  削除
                </button>
                <button className="btn clear" data-micromodal-close>
                  戻る
                </button>
              </footer>
            </div>
          </div>
        </div>

        <div className="micromodal" id="modal-remove-product-complete" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-remove-product-complete-title"
            >
              <header>
                <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
                <h2 id="modal-remove-product-complete-title">商品の削除</h2>
              </header>
              <main id="modal-remove-product-complete-content">
                <p>「{removeItem ? removeItem.title : ''}」を削除しました。</p>
              </main>
              <footer>
                <button className={base.sectionBtn} data-micromodal-close>
                  ＯＫ
                </button>
              </footer>
            </div>
          </div>
        </div>

        <div className="micromodal" id="modal-quantity-modify" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-quantity-modify-title"
            >
              <header>
                <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
                <h2 id="modal-quantity-modify-title">数量の変更</h2>
              </header>
              <main id="modal-quantity-modify-content">
                <p>
                  数量を選択してください。
                  <br />
                  変更は次回のご注文から反映されます。
                </p>
                <SpinButton min={1} value={quantityItem ? quantityItem.quantity : 1} onChange={onChangeQuantity} />
              </main>
              <footer>
                <button className={base.sectionBtn} disabled={pageStatus.quantityAction} onClick={onClickQuantityAction}>
                  保存
                </button>
              </footer>
            </div>
          </div>
        </div>
        <div className="micromodal" id="modal-quantity-modify-complete" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-quantity-modify-complete-title"
            >
              <header>
                <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
                <h2 id="modal-quantity-modify-complete-title">数量の変更</h2>
              </header>
              <main id="modal-quantity-modify-complete-content">
                <p>
                  数量の変更を受け付けました。
                  <br />
                  次回のご注文から反映されます。
                </p>
              </main>
              <footer>
                <button className={base.sectionBtn} data-micromodal-close>
                  ＯＫ
                </button>
              </footer>
            </div>
          </div>
        </div>
        <div className="micromodal" id="modal-error" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div role="dialog" className={base.micromodalOverlayDialog} aria-modal="true" aria-labelledby="modal-error-title">
              <header>
                <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
                <h2 id="modal-error-title">エラー</h2>
              </header>
              <main id="modal-error-content">
                <p>エラーが発生しました。店舗へお問い合わせください。</p>
              </main>
              <footer>
                <button className={base.sectionBtn} data-micromodal-close>
                  ＯＫ
                </button>
              </footer>
            </div>
          </div>
        </div>
      </div>
      {/* /注文詳細 */}
      {/* </div> */}

      <div className="micromodal" id="modal-allow-modify-day" aria-hidden="true">
        <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1} data-micromodal-close>
          <div
            role="dialog"
            className={base.micromodalOverlayDialog}
            aria-modal="true"
            aria-labelledby="modal-allow-modify-day-title"
          >
            <header>
              <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
              <h2 id="modal-allow-modify-day-title">{allowModifyDay.title}</h2>
            </header>
            <main id="modal-allow-modify-day-content">
              <p>
                {allowModifyDay.title}は次回ご注文日の{allowModifyDay.day}日前以降はご利用できません。
                <br />
                次回のご注文日、【{dayjs(nextBillingDate).format('YYYY/MM/DD')}】以降にご利用が可能となります。
              </p>
            </main>
            <footer>
              <button className={base.sectionBtn} data-micromodal-close>
                ＯＫ
              </button>
            </footer>
          </div>
        </div>
      </div>
      <div className="micromodal" id="modal-stock-error" aria-hidden="true">
        <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
          <div
            role="dialog"
            className={base.micromodalOverlayDialog}
            aria-modal="true"
            aria-labelledby="modal-stock-error-title"
          >
            <header>
              <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button>
              <h2 id="modal-stock-error-title">商品の数量変更</h2>
            </header>
            <main id="modal-stock-error-content">
              <p>
                在庫がありません。
                <br />
                入荷をお待ちいただくか、他の商品に変更をお願いします。
              </p>
            </main>
            <footer>
              <button className={base.sectionBtn} data-micromodal-close>
                ＯＫ
              </button>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
};
